<template>
  <div v-if="disasterNo && isAuth">
    <!-- 共通ヘッダー（タイトル/サブタイトル） -->
    <div class="content-header">
      <h1 class="page-title">
        <i class="far fa-check-circle"></i>
        代替医療機関等の確定
      </h1>
    </div>
    <error-message :error-object="errorObject" />
    <success-message :success-object="successObject" />
    <div>
      <section>
        <!-- 一覧部 -->
        <div class="content-card">
          <div
            style="display:flex; justify-content:space-between; align-items:center; margin-bottom:16px; flex-wrap:wrap;"
          >
            <div
              style="display:flex; align-items:center; gap:16px; flex-wrap:wrap;"
          >
              <h2 class="card-title" style="margin:0;">
                避難元／避難先の確定一覧
              </h2>
              <select
                v-model="evaCityFilter"
                style="padding:8px 12px; border:1px solid #c7c7c7; border-radius:4px; font-size:14px; min-width:150px;"
              >
                <option value="">避難元の市町を絞込</option>
                <option
                  v-for="city in uniqueCitiesEva"
                  :key="city"
                  :value="city"
                  >{{ city }}</option
                >
              </select>
              <select
                v-model="tempCityFilter"
                style="padding:8px 12px; border:1px solid #c7c7c7; border-radius:4px; font-size:14px; min-width:150px;"
              >
                <option value="">受入先の市町を絞込</option>
                <option
                  v-for="city in uniqueCitiesTemporary"
                  :key="city"
                  :value="city"
                  >{{ city }}</option
                >
              </select>
            </div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="btn-secondary" @click="toggleDoneFilter">
                {{ showDoneOnly ? "未確定情報のみ表示" : "確定情報のみ表示" }}
              </v-btn>
              <v-btn class="btn-primary" @click="exportExcel()">
                Excel出力
              </v-btn>
              <v-btn class="btn-primary" @click="confirm">
                {{ showDoneOnly ? "確定取消" : "確定" }}
              </v-btn>
            </v-card-actions>
          </div>
          <div
            class
            :style="{ height: tableHeight() + 'px', overflow: 'auto' }"
          >
            <table class="table adjustment-table">
              <thead>
                <tr>
                  <th v-if="showDoneOnly" rowspan="3">取消<br />選択</th>
                  <th colspan="5">避難元</th>
                  <th rowspan="3">避難<br />可能</th>
                  <th colspan="9">避難先</th>
                </tr>
                <tr>
                  <th
                    rowspan="2"
                    style="cursor:pointer;"
                    @click="sortBy('ori_municip_name')"
                  >
                    市町名
                    <span v-if="sortKey === 'ori_municip_name'">
                      <i
                        :class="[
                          'fas',
                          sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                        ]"
                      ></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-sort"></i>
                    </span>
                  </th>
                  <th rowspan="2">施設詳細種別</th>
                  <th
                    rowspan="2"
                    style="cursor:pointer;"
                    @click="sortBy('ori_fa_name')"
                  >
                    避難元施設名
                    <span v-if="sortKey === 'ori_fa_name'">
                      <i
                        :class="[
                          'fas',
                          sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                        ]"
                      ></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-sort"></i>
                    </span>
                  </th>
                  <th rowspan="2">病床数</th>
                  <th
                    rowspan="2"
                    style="cursor:pointer;"
                    @click="sortBy('eva_fa_name')"
                  >
                    使用困難な施設名
                    <span v-if="sortKey === 'eva_fa_name'">
                      <i
                        :class="[
                          'fas',
                          sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                        ]"
                      ></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-sort"></i>
                    </span>
                  </th>
                  <th
                    rowspan="2"
                    style="cursor:pointer;"
                    @click="sortBy('temp_municip_name')"
                  >
                    受入先市町名
                    <span v-if="sortKey === 'temp_municip_name'">
                      <i
                        :class="[
                          'fas',
                          sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                        ]"
                      ></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-sort"></i>
                    </span>
                  </th>
                  <th rowspan="2">施設詳細種別</th>
                  <th
                    rowspan="2"
                    style="cursor:pointer;"
                    @click="sortBy('temp_fa_name')"
                  >
                    代替の避難先施設名
                    <span v-if="sortKey === 'temp_fa_name'">
                      <i
                        :class="[
                          'fas',
                          sortOrder === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
                        ]"
                      ></i>
                    </span>
                    <span v-else>
                      <i class="fas fa-sort"></i>
                    </span>
                  </th>
                  <th colspan="2">原発からの</th>
                  <th rowspan="2">病床数</th>
                  <th rowspan="2">受入<br />可能者数</th>
                  <th colspan="2">施設間の</th>
                </tr>
                <tr>
                  <th>方角</th>
                  <th>直線距離</th>
                  <th>方角</th>
                  <th>直線距離</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in sortedTemporaries" :key="data.key">
                  <td v-if="showDoneOnly" style="text-align: center;">
                    <input type="checkbox" v-model="data.cancel_flg" />
                  </td>
                  <td style="text-align: left;">{{ data.ori_municip_name }}</td>
                  <td style="text-align: left;">
                    {{ data.ori_fa_details_type_name }}
                  </td>
                  <td style="text-align: left;">
                    {{ data.ori_fa_name }}
                  </td>
                  <td style="text-align: right;">
                    {{ data.ori_max_capacity }}
                  </td>
                  <td style="text-align: left;">{{ data.eva_fa_name }}</td>
                  <td style="text-align: center;">
                    <input
                      type="checkbox"
                      v-model="data.eva_city_flg"
                      :disabled="showDoneOnly"
                    />
                  </td>
                  <td style="text-align: left;">
                    {{ data.temp_municip_name }}
                  </td>
                  <td style="text-align: left;">
                    {{ data.temp_fa_details_type_name }}
                  </td>
                  <td style="text-align: left;">{{ data.temp_fa_name }}</td>
                  <td style="text-align: center;">
                    {{ data.temp_direction_from_npp_name }}
                  </td>
                  <td style="text-align: right;">
                    {{ data.temp_distance_from_npp }} km
                  </td>
                  <td style="text-align: right;">
                    {{ data.temp_max_capacity }}
                  </td>
                  <td style="text-align: right;">
                    {{ data.temp_acceptable_capacity }}
                  </td>
                  <td style="text-align: center;">
                    {{ data.direction_from_fa_name }}
                  </td>
                  <td style="text-align: right;">
                    {{ data.distance_from_fa }} km
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <ConfirmDialog ref="confirmDialog" />
    <ErrorDialog ref="errorDialog" />
    <v-overlay :value="overlay" opacity="1" color="white">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
  <div v-else>
    <div v-if="disasterNo">
    <error-message :error-object="errorObject" />
  </div>
  </div>
</template>

<script>
import ExcelJS from "exceljs";
import messageUtils from "@/mixins/message-utils";
import { ErrorTodoMessages } from "@/js/constants/error-messages";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { ScreenId } from "@/js/value-objects/screen-id";

const adjustmentSystemRepository = RepositoryFactory.get("adjustmentSystem");
const confirmationRepository = RepositoryFactory.get("confirmationVul");

const LIST_MAX_HEIGHT = 620;

export default {
  name: "ConfirmationVul",
  mixins: [messageUtils],
  components: {
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage"),
    ErrorDialog: () => import("@/components/adjustment/AdErrorDialog"),
    ConfirmDialog: () => import("@/components/adjustment/AdConfirmDialog")
  },
  props: {
    disasterNo: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    overlay: false,
    isAuth: false,
    isInitError: false,
    tempCityFilter: "",
    evaCityFilter: "",
    showDoneOnly: false,
    sortKey: "",
    sortOrder: "asc",
    temporaryList: []
  }),

  computed: {
    // 県の絞込み
    filteredPre() {
      return this.temporaryList.filter(temporary => {
        return this.isValidPre(temporary);
      });
    },
    // 一覧のソート
    sortedTemporaries() {
      const filtered = this.filteredPre;
      if (!this.sortKey) return filtered;

      return [...filtered].sort((a, b) => {
        let aVal = a[this.sortKey];
        let bVal = b[this.sortKey];

        const modifier = this.sortOrder === "asc" ? 1 : -1;

        if (aVal < bVal) return -1 * modifier;
        if (aVal > bVal) return 1 * modifier;
        return 0;
      });
    },
    // 一覧の市町名絞込みリスト作成
    uniqueCitiesTemporary() {
      const cities = [
        ...new Set(
          this.temporaryList.map(temporary => temporary.temp_municip_name)
        )
      ];
      return cities.filter(city => city).sort();
    },
    // 一覧の市町名絞込みリスト作成
    uniqueCitiesEva() {
      const cities = [
        ...new Set(
          this.temporaryList.map(temporary => temporary.ori_municip_name)
        )
      ];
      return cities.filter(city => city).sort();
    }
  },

  async mounted() {
    await this.initialize();
    if (this.disasterNo === "" || this.isInitError) return;
    await this.getList();
  },

  methods: {
    // 初期処理
    async initialize() {
      this.clearMessage();
      this.overlay = true;
      try {
        this.clearSort();
        /* 権限取得 */
        const payload = {
          disasterNo: this.disasterNo
        };
        await adjustmentSystemRepository
          .list(ScreenId.SF4101, payload)
          .then(response => {
            this.isInitError = false;
            this.isAuth = response.data.isAuth;
          })
          .catch(e => {
            this.isInitError = true;
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.isInitError = true;
        this.handleUpdateError(error);
        console.error("ユーザーの権限取得に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    // 検索条件表示非表示の時の一覧の高さ調整
    tableHeight() {
      return LIST_MAX_HEIGHT;
    },
    // 一覧のソート処理
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
    clearSort() {
      this.sortKey = "";
      this.sortOrder = "asc";
    },
    isValidPre(data) {
      if (this.tempCityFilter && data.temp_municip_name !== this.tempCityFilter)
        return false;

      if (this.evaCityFilter && data.ori_municip_name !== this.evaCityFilter)
        return false;

      if (this.showDoneOnly && !data.pre_flg) return false;
      if (!this.showDoneOnly && data.pre_flg) return false;

      return true;
    },
    // 仮登録データの表示切り替え
    toggleDoneFilter() {
      this.clearMessage();
      this.showDoneOnly = !this.showDoneOnly;
    },
    // 一覧の取得
    async getList() {
      this.overlay = true;
      try {
        this.clearSort();
        const payload = {
          disasterNo: this.disasterNo
        };

        /* 代替避難先の仮登録一覧取得 */
        await confirmationRepository
          .list(ScreenId.SF4101, payload)
          .then(response => {
            this.temporaryList = response.data.results;
          })
          .catch(e => {
            this.handleUpdateError(e);
          });
      } catch (error) {
        this.handleUpdateError(error);
        console.error("代替避難先の仮登録一覧の取得に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    // EXCEL出力
    async exportExcel() {
      let templateFileName;
      let downloadFileName;
      let dateCell;

      this.overlay = true;
      try {
        if (!this.temporaryList.length > 0) {
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE48001);
          return;
        }

        templateFileName = "confirmation_vul_list.xlsx";
        downloadFileName = "避難元避難先確定一覧（県）";
        dateCell = "P2";

        /* タイムスタンプ算出 */
        let now = new Date();
        let year = now.getFullYear();
        let month = ("00" + (now.getMonth() + 1)).slice(-2);
        let day = ("00" + now.getDate()).slice(-2);
        let hour = ("00" + now.getHours()).slice(-2);
        let minute = ("00" + now.getMinutes()).slice(-2);
        let timeStamp = year + month + day + hour + minute;
        let timeStamp2 =
          year + "/" + month + "/" + day + " " + hour + ":" + minute;

        // 固定のExcelファイルを取得（publicフォルダに配置されていると仮定）
        const response = await fetch("/template/" + templateFileName);
        const arrayBuffer = await response.arrayBuffer();

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(arrayBuffer);
        const worksheet = workbook.getWorksheet(1); // 最初のシートを取得

        // 罫線スタイルを定義
        const borderStyle = {
          style: "thin",
          color: { argb: "FF000000" }
        };

        //5行目まではヘッダー
        var rowNo = 5;
        this.temporaryList.forEach(data => {
          if (!this.isValidPre(data)) return;

          rowNo++;
          const rowData = [
            rowNo - 5,
            data.ori_municip_name,
            data.ori_fa_details_type_name,
            data.ori_fa_name,
            Number(data.ori_max_capacity),
            data.eva_fa_name,
            data.eva_city_flg_db ? "○" : "",
            data.temp_municip_name,
            data.temp_fa_details_type_name,
            data.temp_fa_name,
            data.temp_direction_from_npp_name,
            data.temp_distance_from_npp + " km",
            Number(data.temp_max_capacity),
            Number(data.temp_acceptable_capacity),
            data.direction_from_fa_name,
            data.distance_from_fa + " km"
          ];

          const row = worksheet.insertRow(rowNo, rowData);

          // 各セルに罫線を設定
          row.eachCell(cell => {
            cell.border = {
              top: borderStyle,
              left: borderStyle,
              bottom: borderStyle,
              right: borderStyle
            };
          });
        });

        const cell = worksheet.getCell(dateCell);
        cell.value = "出力日時：" + timeStamp2;

        // 編集済みファイルをダウンロード
        const editedBuffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([editedBuffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = downloadFileName + "_" + timeStamp + ".xlsx";
        link.click();
      } catch (error) {
        console.error("EXCEL出力に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    },
    // 仮登録処理
    async confirm() {
      let msg = "";
      try {
        if (!this.temporaryList.length > 0) {
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE48001);
          return;
        }

        msg = this.showDoneOnly
          ? "確定した代替避難所を取り消しします。\nよろしいですか？"
          : "一覧の内容で避難可否を確定します。\nよろしいですか？";
        const btnText = this.showDoneOnly ? "確定取消" : "確定";

        // 更新確認ダイアログを表示
        const result = await this.$refs.confirmDialog.open(msg, btnText);
        if (!result) return;

        this.clearMessage();
        this.overlay = true;

        const paramList = [];
        this.temporaryList.forEach(data => {
          if (!this.isValidPre(data)) return;
          if (this.showDoneOnly && !data.cancel_flg) return;

          paramList.push({
            evaCityFlg: data.eva_city_flg || false,
            preFlg: data.pre_flg,
            cancelFlg: data.cancel_flg,
            oriFaId: data.ori_fa_id,
            evaFaId: data.eva_fa_id,
            tempFaId: data.temp_fa_id
          });
        });

        if (!paramList.length > 0) {
          await this.$refs.errorDialog.open(ErrorTodoMessages.ERWE48004);
          return;
        }

        const payload = {
          disasterNo: this.disasterNo,
          list: paramList
        };

        let isSuccess = false;
        await confirmationRepository
          .update(ScreenId.SF4101, payload)
          .then(response => {
            isSuccess = true;
            this.handleSuccess(response);
          })
          .catch(error => {
            this.handleUpdateError(error);
          });

        if (isSuccess) {
          // 登録後の最新データを取得する
          await this.getList();
        }
      } catch (error) {
        console.error("代替避難所の確定に失敗しました:", error);
      } finally {
        this.overlay = false;
      }
    }
  }
};
</script>
